"use client"

import { create } from "zustand"

interface InboxShipmentRequestState {
    shipmentDocId: string | null
    requestOpenForShipment: (shipmentDocId: string) => void
    clearShipmentRequest: () => void
}

export const useInboxShipmentRequestStore = create<InboxShipmentRequestState>()(
    set => ({
        shipmentDocId: null,
        requestOpenForShipment: shipmentDocId => set({ shipmentDocId }),
        clearShipmentRequest: () => set({ shipmentDocId: null }),
    })
)
